/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MovimentacaoLoteAliases {
  ACTION_IMPORT = 'action-import',
  ACTION_MODELO = 'action-modelo',
  AUTOCOMPLETE_0 = 'autocomplete-0',
  BUTTON_OK = 'button-ok',
  CONTEXTUAL_BAR = 'contextual-bar',
  DATE_FIELD_LOTE_END = 'date-field-lote-end',
  DATE_FIELD_LOTE_START = 'date-field-lote-start',
  DECK_LOTE = 'deck-lote',
  FETCH_0 = 'fetch-0',
  FETCH_LOTE = 'fetch-lote',
  FIELD_CONTRATACAO = 'field-contratacao',
  FIELD_INCLUSAO = 'field-inclusao',
  FIELD_LIBERACAO = 'field-liberacao',
  FIELD_LOTE = 'field-lote',
  FIELD_SEND_DATE_END = 'field-send-date-end',
  FIELD_SEND_DATE_START = 'field-send-date-start',
  FIELD_STATUS = 'field-status',
  FILE_UPLOADER_MODAL = 'file-uploader-modal',
  FILTERED_LIST_LOTE = 'filtered-list-lote',
  HPMS_CUSTOM_CARD_LOTE = 'hpms-custom-card-lote',
  HPMS_CUSTOM_DIALOG = 'hpms-custom-dialog',
  INPUT_LOTE = 'input-lote',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LOADER_0 = 'loader-0',
  LOTE_FILTER = 'lote-filter',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_ERRORS = 'panel-errors',
  PANEL_FILE_UPLOADER_MODAL = 'panel-file-uploader-modal',
  PANEL_LOADER = 'panel-loader',
  PANEL_MAIN = 'panel-main',
  PANEL_MOVIMENTACAO_LOTE = 'panel-movimentacao-lote',
  PANEL_TEXTO_PADRAO = 'panel-texto-padrao',
  REPEATER_ERRORS = 'repeater-errors',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_CONTRATACAO = 'text-contratacao',
  TEXT_INCLUSAO = 'text-inclusao',
  TEXT_LIBERACAO = 'text-liberacao',
  TEXT_TEXTO_PADRAO = 'text-texto-padrao',
}
export { MovimentacaoLoteAliases };
